// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"fbmodal_modalContent__1qhui","fbImg":"fbmodal_fbImg__2I8j2"};